import React from 'react';
import { Link } from 'react-router-dom';
import { AtSign, Mail, MessageCircle, Send } from 'lucide-react';

export const Footer: React.FC = () => {
  return (
    <footer className="border-t border-[rgb(var(--border))] bg-[rgb(var(--card))] py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div>
            <h3 className="text-lg font-bold text-primary">EdyTech</h3>
            <p className="mt-2 text-sm text-[rgb(var(--light-secondary))]">Professional device repairs, training, and premium gadgets.</p>
            <div className="mt-4 flex space-x-4">
              <a href="#" aria-label="X (Twitter)"><AtSign size={20} /></a>
              <a href="#" aria-label="Email"><Mail size={20} /></a>
              <a href="#" aria-label="Messenger"><MessageCircle size={20} /></a>
              <a href="#" aria-label="Telegram"><Send size={20} /></a>
            </div>
          </div>
          <div>
            <h4 className="font-semibold">Quick Links</h4>
            <ul className="mt-2 space-y-2 text-sm">
              <li><Link to="/repairs">Repairs</Link></li>
              <li><Link to="/shop">Shop</Link></li>
              <li><Link to="/courses">Courses</Link></li>
              <li><Link to="/about">About</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold">Support</h4>
            <ul className="mt-2 space-y-2 text-sm">
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/terms">Terms</Link></li>
              <li><Link to="/privacy">Privacy</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold">Newsletter</h4>
            <p className="mt-2 text-sm text-[rgb(var(--light-secondary))]">Subscribe for updates and offers.</p>
            <form className="mt-2 flex">
              <input type="email" placeholder="Your email" className="flex-1 rounded-l-lg border border-[rgb(var(--border))] bg-[rgb(var(--background))] px-3 py-2 text-sm" />
              <button className="rounded-r-lg bg-primary px-4 py-2 text-sm text-white hover:bg-primary-dark">Subscribe</button>
            </form>
          </div>
        </div>
        <div className="mt-8 border-t border-[rgb(var(--border))] pt-4 text-center text-sm text-[rgb(var(--light-secondary))]">
          © {new Date().getFullYear()} EdyTech Smart Board Repairs. All rights reserved.
        </div>
      </div>
    </footer>
  );
};